import React from 'react'
import { motion } from 'framer-motion'
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

const DIMENSIONS = [
  { id: 'capability', title: 'Capability fit' },
  { id: 'culture', title: 'Cultural readiness' },
  { id: 'strategy', title: 'Strategic fit' },
  { id: 'ownership', title: 'Ownership & longevity' },
  { id: 'risk', title: 'Risk & dependency' },
  { id: 'resourcing', title: 'Resourcing & time' },
  { id: 'decision', title: 'Decision-making quality' },
  { id: 'experience', title: 'Experience fit' },
  { id: 'purpose', title: 'User insight & rationale' }, 
  { id: 'learning', title: 'Learning & adaptability' },
]

// 👇 Add this block
const CustomTooltip = ({ active, payload, label, showSectorAverage }) => {
  if (!active || !payload || !payload.length) return null

  const dataPoint = payload[0].payload
  const yourScore = dataPoint.score
  const sectorScore = dataPoint.sector

  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #E5E7EB',
        borderRadius: 4,
        padding: '0.6rem 0.8rem',
        boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{label}</div>
      <div style={{ color: '#DB2777', fontWeight: 500 }}>
        Your score: {yourScore}
      </div>
      {showSectorAverage && (
        <div style={{ color: '#6B7280' }}>
          Sector average: {sectorScore}
        </div>
      )}
    </div>
  )
}


function RadarChartComponent({ scores, sectorAverages, showSectorAverage }) {
  const data = DIMENSIONS.map((dim) => ({
  dimension: dim.title,
  score: scores[dim.id] || 0,
  sector: sectorAverages ? sectorAverages[dim.id] || 0 : 0,
}))

  return (
    <div style={{ width: '100%', height: 500 }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart outerRadius="80%" data={data}>
          {/* 🔮 Define pink gradient fill */}
          <defs>
            <linearGradient id="pinkGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#F472B6" stopOpacity={0.8} /> {/* Light pink */}
              <stop offset="100%" stopColor="#DB2777" stopOpacity={0.8} /> {/* Deeper pink */}
            </linearGradient>
          </defs>
          <PolarGrid stroke="#ccc" />
          <PolarAngleAxis
            dataKey="dimension"
            tick={({ payload, x, y, textAnchor }) => {
                const angleRad = (-payload.coordinate * Math.PI) / 180
                const offset = 5 // adjust this to increase/decrease spacing

                return (
                <text
                    x={x + offset * Math.cos(angleRad)}
                    y={y + offset * Math.sin(angleRad)}
                    textAnchor={textAnchor}
                    dominantBaseline="central"
                    fontSize={12}
                    fill="#374151"
                >
                    {payload.value}
                </text>
                )
            }}
            />
          <PolarRadiusAxis domain={[0, 5]} tickCount={6} axisLine={false} tick={false} />
          <Radar
            name="Your Score"
            dataKey="score"
            stroke="#DB2777" // Brand pink outline
            fill="url(#pinkGradient)" // Gradient fill
            fillOpacity={0.8}
            isAnimationActive={true}
            animationDuration={1000}
            animationEasing="ease-out"
          />
                  {showSectorAverage && (
          <Radar
            name="Sector Average"
            dataKey="sector"
            stroke="#6B7280"           // grey stroke
            fill="#D1D5DB"             // light grey fill
            fillOpacity={0.4}
            isAnimationActive={false}
          />
        )}

          <Tooltip content={<CustomTooltip showSectorAverage={showSectorAverage} />} />

        </RadarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default RadarChartComponent
